<template>
    <transition name="fade">
        <div
            v-if="visible || delayed"
            class="uik-overlay"
            :style="{ 'background-color': 'rgba(0, 0, 0, ' + (opacity/100) + ')' }"
            @click="close"
        />
    </transition>
</template>

<script>
export default {
    name: "UikOverlay",
    props: {
        visible: { type: Boolean, default: null },
        opacity: { type: Number, default: 50 }
    },
    data () {
        return {
            delayed: false
        }
    },
    created () {
        if (this.visible === null) {
            this.delayed = false
            setTimeout(() => { this.delayed = true }, 50)
        }
    },
    methods: {
        close () {
            this.$emit("close", false)
        }
    }
}
</script>

<style lang="scss">
.uik-overlay {
    position: fixed;
    z-index: 10;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
}
</style>
